import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AumBreadcrumbComponent } from './breadcrumb';
import { I18NextModule } from 'angular-i18next';

const EXPORTED_DECLARATIONS = [AumBreadcrumbComponent];

@NgModule({
    declarations: [EXPORTED_DECLARATIONS],
    providers: [],
    imports: [CommonModule, I18NextModule, RouterModule],
    exports: [EXPORTED_DECLARATIONS],
})
export class AumBreadcrumbModule {}
